import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M16.125 0H1.875C.842 0 0 .84 0 1.875v14.25C0 17.159.842 18 1.875 18h14.25C17.158 18 18 17.16 18 16.125V1.875A1.877 1.877 0 0 0 16.125 0m.375 1.875V8.25H9.75V1.5h6.375c.207 0 .375.169.375.375M1.875 1.5H8.25v6.75H1.5V1.875c0-.206.168-.375.375-.375M1.5 16.125V9.75h6.75v6.75H1.875a.376.376 0 0 1-.375-.375m14.625.375H9.75V9.75h6.75v6.375a.376.376 0 0 1-.375.375"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h18v18H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }